// Este servicio sirve para centralizar la lectura de propriedades cuando llevan algo de logica.
// mas que nada se usa en los servicios
// - engine-fields.service
// - engine-cells.service
// pero se puede usar donde sea.
export default {
  getNgModel,
  getDisabled,
  getPattern,
  getDefaultValue,
  getVisible,
  getFbFlash,
};

function getNgModel({ model = '' }) {
  // @odeniel - transforma "CAB.LIN.CAMPO" => "LIN[CAMPO]"
  // antes "CAB.LIN.CAMPO" => "LIN.CAMPO": return engineUtilsService.getLastItems(viewField.model, 2) || ''
  // pero daba problema con campos con nombre numerico, ej "FORM.1001"
  const splitted = model.split('.');
  if (splitted.length < 2) {
    return model;
  }
  const lastTwo = splitted.slice(-2);
  return `${lastTwo[0]}['${lastTwo[1]}']`;
}

function getDisabled(viewField, isReadOnly) {
  if (_isDefined(viewField.fixed) || isReadOnly) {
    return 'true';
  }

  // si el campo tiene un disabled === false -> forzamos a que este habilitado:
  // es para permitir habilitar un campo dentro de una sección desabilitada
  if (viewField.disabled === false || viewField.disabled === 'false') {
    return '';
  }

  let disabled = '';
  try {
    if (_isDefined(viewField.parent.disabled)) {
      if (viewField.parent.disabled === true) {
        return 'true';
      } // siempre sera true, no hace falta mas
      disabled += viewField.parent.disabled;
    }
  } catch (e) {
    if (!viewField.parent) {
      // @odeniel añado control de error, contactar conmigo si salta
      console.error(
        `ecFormBuilder: el "parent" no existe para este property. Si se usa un servicio personalizado (y no los setCommonAttributes), debe guardarse el parent antes de recorrer sus properties. property:`,
        viewField
      );
    } else {
      throw e;
    }
  }
  if (_isDefined(viewField.disabled)) {
    if (viewField.disabled === true) {
      return 'true';
    } // siempre sera true, no hace falta mas
    disabled = disabled ? `(${disabled}) || ${viewField.disabled}` : viewField.disabled;
  }
  return disabled;
}

function getPattern(pattern = '') {
  /* en un JSON se tiene que escapar caracteres especiales
     https://docs.microsoft.com/en-us/sql/relational-databases/json/how-for-json-escapes-special-characters-and-control-characters-sql-server?view=sql-server-ver15
     para regexp, concierne \, " y /
     La regexp "pattern" viene de un objeto javascript entonces ya esta correcta.
     Solo que para angularjs, y el ng-pattern, como va por atributo html, no soporta el ",
     que tenemos que reemplazar por " -> &quot;
    */
  return pattern.replace(/"/g, '&quot;');
}

function getDefaultValue(viewField) {
  if (_isDefined(viewField.fixed)) {
    return viewField.fixed;
  }
  if (_isDefined(viewField.default)) {
    return viewField.default;
  }
  return '';
}

function getVisible(viewField) {
  if (viewField.visible === true || viewField.visible === 'true') {
    return '';
  }
  if (_isDefined(viewField.visible)) {
    return viewField.visible;
  }
  return '';
}

function getFbFlash(viewField, viewParent = {}) {
  // @odeniel el padre sobreescribira al hijo si esta definido
  if (viewParent.fbFlash === true) {
    // es que si el padre gestiona el flash, entonces el hijo no tiene que hacerlo directamente.
    return false;
  }
  if (typeof viewField.fbFlash === 'boolean') {
    return viewField.fbFlash;
  }
  // @odeniel si es un tipo definido con fbFlash - (esta lista debe ir completandose para llevar casi todos los tipos "registro")
  if (['array', 'list', 'tabs'].includes(viewField.type)) {
    return true;
  }
  return false;
}

function _isDefined(value) {
  return typeof value !== 'undefined' && value !== '';
}
